import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon PinDeselectedIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const PinDeselectedIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 56 56">
      <g>
        <path d="M2.5,55.5c-0.51,0-1.03-0.2-1.42-0.59c-0.78-0.78-0.78-2.05,0-2.83l14.24-14.24L5.4,27.92v-2.83l4.47-4.47 l1.25-0.58l11.65-0.98l6.83-6.84l1-7.22l0.57-1.15l3.36-3.36h2.83L55.5,18.64v2.83l-3.36,3.36l-1.43,0.59l-8.17-0.05l-6.65,6.65 l0.08,12.68l-0.59,1.43l-4.47,4.47h-2.83l-9.92-9.92L3.92,54.91C3.53,55.3,3.02,55.5,2.5,55.5z M19.58,36.42l9.92,9.92l2.46-2.47 l-0.08-12.68l0.59-1.43l7.83-7.83l1.43-0.59l8.17,0.05l1.35-1.35l-15.3-15.3L34.49,6.2l-0.98,7.21l-0.57,1.15L25.1,22.4l-1.25,0.58 L12.2,23.96L9.66,26.5L19.58,36.42z" />
      </g>
    </Icon>
  )
}
export default PinDeselectedIcon
